$(document).ready(function(){
  //append and prepend to footer
  $(".menu-footer-main-container").prepend("<hr/>");
  $("footer#colophon").children("section.footer-widgets").prepend("<hr/>");

  //for header
  $(".login-item").children().prepend('<div class="circle-icon"><i class="material-icons"> person</i></div>');
  $("#navbar-menu-icon").click(function(){
    change_icon(this); 
  });

  //submit rate for button
  $('#rate-form-select').on('change', function(){
    submit_rate_form();
  });



// events for modal video

// Handle show/hide video image hover effect based on visibility, to manage better the layout structure previously constructed
$("#watchVideoBtn").mouseenter(function() {
  $("#bluVideoImg").removeClass("no-visible");
});

$("#watchVideoBtn").mouseleave(function() {
  $("#bluVideoImg").addClass("no-visible");
});

   $("#watchVideoBtn").click(function(){
    play_popup_video('bluVideo', 'play');
  });

  $('#videoModal').on('show.bs.modal', function () {
    play_popup_video('bluVideo', 'play');
  });

  $("#videoModal").on("hidden.bs.modal", function () {
    play_popup_video('bluVideo', 'pause');
  });

  //capture click in find my rating exam

  let findMyRatingExam = document.getElementsByClassName('btn btn-call-to-action');

  for(let i=0; i<findMyRatingExam.length; i++){
    if(findMyRatingExam[i] && findMyRatingExam[i].innerHTML == 'Find My Rating Exam'){
      findMyRatingExam[i].onclick = function() {
        gtag('event', 'Click', {
          'event_category': 'Click',
          'event_label': 'Click sign-up',
          'value': 'Find My Rating Exam'
        });
      };
    }
  }

  //capture click in sign up button
  let signUpButton = document.getElementsByClassName('nav-link');

  for(let i=0; i<signUpButton.length; i++){
    if(signUpButton[i] && signUpButton[i].innerHTML == 'Sign Up'){
      signUpButton[i].onclick = function() {
        gtag('event', 'Click', {
          'event_category': 'Click',
          'event_label': 'Click sign-up',
          'value': 'Sign Up'
        });
      };
    }
  }
});

function change_icon($element){
  $spanChild = $($element).children("span.navbar-toggler-icon");
  if($($element).attr("aria-expanded")==="true"){
    $spanChild.children("i#open-navbar-menu").removeClass("d-none");
    $spanChild.children("svg#close-navbar-menu").addClass("d-none");
    $("#site-navigation").removeClass("menu-open");
    $("#content").children(".wp-bp-main-content").removeClass("d-none d-md-block");
    $("#colophon").removeClass("d-none d-md-block");
    if(!($("#page").hasClass("transparent-header"))){
      $("#content").first().removeClass("d-none");
    }
  }
  else{
    $spanChild.children("i#open-navbar-menu").addClass("d-none");
    $spanChild.children("svg#close-navbar-menu").removeClass("d-none");
    $("#site-navigation").addClass("menu-open");
    $("#content").children(".wp-bp-main-content").addClass("d-none d-md-block");
    $(".transparent-header").children("#masthead").height(0);
    $("#colophon").addClass("d-none d-md-block");
    if(!($("#page").hasClass("transparent-header"))){
      $("#content").first().addClass("d-none");
    }
  }
}

function submit_rate_form() {
  $value = $('#rate-form-select option:selected').val();
  $('#submit-rate-form').val($value);
  $submit_url ="/auth/sign-up" + "?rate=" + $value ;
}

function play_popup_video(videoId, method) {

  const player = document.getElementById(videoId);

  if (player) {
    switch (method) {
      case 'play':
        player.play();
        break;
      case 'pause':
        player.pause();
        player.currentTime = 0
        break;
    }
  }
}